<template>
  <div>
    <section>
      <div class="title-block clearfix">
        利用人数
        <span class="float-text">計8名まで購入できます。</span>
      </div>

      <div class="column">
        <div class="field">
          <label>おとな</label>
          <div class="select-wrap">
            <select v-model="adult">
              <option :value="0">{{ 0 }}</option>
              <option
                v-for="n in 8 - totalSelectedCount + adult"
                :key="n"
                :value="n"
              >
                {{ n }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label>こども</label>
          <div class="select-wrap">
            <select v-model="child">
              <option :value="0">{{ 0 }}</option>
              <option
                v-for="n in 8 - totalSelectedCount + child"
                :key="n"
                :value="n"
              >
                {{ n }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectDivision",
  props: {
    adult: {
      type: Number,
      required: true,
    },
    child: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const adult = useVModel(props, "adult");
    const child = useVModel(props, "child");
    const totalSelectedCount = computed(() => adult.value + child.value);

    return {
      adult,
      child,
      totalSelectedCount,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.float-text {
  float: right;
  font-weight: normal;
}
.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}
.field {
  position: relative;
  margin: 0 0 0 0;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 3vw;
  margin-top: -4px;
}
</style>
